import React from 'react';
import { useAtualizacao } from '../hooks/useAtualizacao';

/**
 * Faixa discreta no rodapé quando há atualização da versão desktop.
 *
 * Não renderiza nada no navegador nem quando o app está em dia — pode ficar
 * montado na raiz sem custo.
 *
 * Dois casos, com desfechos diferentes:
 *  'disponivel'          -> botão que baixa, aplica e reinicia
 *  'exige-reinstalacao'  -> só avisa e aponta o instalador; o updater não troca
 *                           o executável, então aplicar aqui não resolveria
 */
const AvisoAtualizacao = () => {
  const {
    estado, versaoNova, binarioExigido, urlInstalador,
    aplicando, erro, aplicar, dispensar, temNovidade,
  } = useAtualizacao();

  if (!temNovidade) return null;

  const reinstalar = estado === 'exige-reinstalacao';

  const caixa = {
    position: 'fixed', right: 16, bottom: 16, zIndex: 99999,
    maxWidth: 380, padding: '12px 14px', borderRadius: 10,
    background: reinstalar ? '#fffbeb' : '#eff6ff',
    border: `1px solid ${reinstalar ? '#fcd34d' : '#bfdbfe'}`,
    boxShadow: '0 6px 24px rgba(0,0,0,0.12)',
    fontSize: 13, color: '#1e293b',
  };
  const botao = {
    padding: '6px 12px', border: 'none', borderRadius: 6,
    background: '#0078d7', color: '#fff', cursor: 'pointer', fontSize: 12.5, fontWeight: 600,
  };
  const secundario = {
    padding: '6px 10px', border: '1px solid #cbd5e1', borderRadius: 6,
    background: '#fff', color: '#475569', cursor: 'pointer', fontSize: 12.5,
  };

  return (
    <div style={caixa} role="status">
      <div style={{ fontWeight: 700, marginBottom: 4 }}>
        <i className={`fas ${reinstalar ? 'fa-triangle-exclamation' : 'fa-arrow-rotate-up'}`} />
        {reinstalar ? ' Reinstalação necessária' : ` Atualização disponível (${versaoNova})`}
      </div>

      <div style={{ color: '#475569', lineHeight: 1.4, marginBottom: 10 }}>
        {reinstalar
          ? `Esta versão exige o programa ${binarioExigido} ou superior. Baixe o pacote e substitua os arquivos da pasta de instalação.`
          : 'O aplicativo será reiniciado para aplicar. Salve o que estiver fazendo antes de continuar.'}
      </div>

      {erro && (
        <div style={{ background: '#fee2e2', color: '#b91c1c', padding: '6px 8px', borderRadius: 6, marginBottom: 8, fontSize: 12 }}>
          {erro}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        {reinstalar ? (
          urlInstalador && (
            <button type="button" style={botao}
              onClick={() => window.Neutralino?.os?.open(urlInstalador)}>
              Baixar pacote
            </button>
          )
        ) : (
          <button type="button" style={botao} onClick={aplicar} disabled={aplicando}>
            {aplicando ? 'Aplicando...' : 'Atualizar e reiniciar'}
          </button>
        )}
        <button type="button" style={secundario} onClick={dispensar} disabled={aplicando}>
          Agora não
        </button>
      </div>
    </div>
  );
};

export default AvisoAtualizacao;
